var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"404","title":"错误路径","sub-title":"对不起，页面不存在或没有权限"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{staticClass:"cus-button",attrs:{"type":"primary"},on:{"click":_vm.onBack}},[_vm._v("返回登录页")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }